import React from 'react';
import { PluginProps } from '../Plugin';

const VerticalSpacer = (props: PluginProps) => {
  const { content } = props;
  return <div style={{ height: content.data.height }} />;
};

export default VerticalSpacer;
